$(document).ready(function () {

    jQuery.validator.addMethod("notNumber", function(value, element, param) {
        var reg = /[0-9]/;
        if(reg.test(value)){
              return false;
        }else{
                return true;
        }
        }, "Numbers not allowed");

        $("#phonenumber").keypress(function (e) {
            if (String.fromCharCode(e.which).match(/[^+0-9]/)) {
                e.preventDefault();
            }
        });
    
        $("#city").keypress(function (e) {
            e = e || window.event;
            var charCode = (typeof e.which == "undefined") ? e.keyCode : e.which;
            var charStr = String.fromCharCode(charCode);
            if (/\d/.test(charStr)) {
                e.preventDefault();
            }
        });

        $("#purchaseintention").on("change", function () {
            setPurchaseIntentionText();
        });
    
        $("#contactreason").on("change", function () {
            contactReasonSelectChange();
          });

          $("#product").on("change", function () {
            setProductText();
        });

    /* CONFIG */
    var formAction = "https://landingreceiver.youandemili.com/api/v1/landing/process/json";

    //$(".submit-button").attr("disabled","disabled"); 


    $("#landing-form").validate({
        errorElement: "span",
        rules: {
            city: 'notNumber'
           }
    });



    //campaign tracking
    var gtmref = getUrlParameter("utm_source");
    var gtmcampaign = getUrlParameter("utm_campaign");
    var gtmmedium = getUrlParameter("utm_medium");
    var gtmcontent = getUrlParameter("utm_content");
    var ae_placement = getUrlParameter("placement");
    var adset = getUrlParameter("adset");
    var campaignname = getUrlParameter("campaign_name");
    
    if (gtmref != undefined) {
        $("#gtmref").val(gtmref);
    }
    if (gtmcampaign != undefined) {
        $("#gtmcampaign").val(gtmcampaign);
    }

    if (gtmmedium != undefined) {
        $("#gtmmedium").val(gtmmedium);
    }

    if (gtmcontent != undefined) {
        $("#gtmcontent").val(gtmcontent);
    }

    if (ae_placement != undefined) {
        $("#placement").val(ae_placement);
    }

    if (adset != undefined) {
        $("#adset").val(adset);
    }

    if (campaignname != undefined) {
        $("#campaignname").val(campaignname);
    }

    $("#phonenumber").keypress(function (e) {
        if (String.fromCharCode(e.which).match(/[^+0-9 ]/)) {
            e.preventDefault();
        }
    });

    $("#city").keypress(function (e) {
        e = e || window.event;
        var charCode = (typeof e.which == "undefined") ? e.keyCode : e.which;
        var charStr = String.fromCharCode(charCode);
        if (/\d/.test(charStr)) {
            e.preventDefault();
        }
    });

    $("#landing-form").submit(function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        var form = $("#landing-form");

        var gdprMarketing = $("input[name=gdpr_1]:checked").val();
        var gdprMarketingThird = $("input[name=gdpr_2]:checked").val();
        console.log("gdprMarketing", gdprMarketing);
        console.log("gdprMarketingThird", gdprMarketingThird);
        if (gdprMarketing === "1" || gdprMarketingThird === "1") {
          $("#contact_email").val("1");
          $("#contact_phone").val("1");
          $("#contact_sms").val("1");
        } else {
          $("#contact_email").val("0");
          $("#contact_phone").val("0");
          $("#contact_sms").val("0");
        }

        if (form.valid()) {
            $("#emailError").addClass("hidden");
            $("#phoneError").addClass("hidden");
            $("#emailError1").addClass("hidden");
            $("#phoneError1").addClass("hidden");
            $(".submit-button").attr("disabled", "disabled");
            $("#waiting-form").removeClass("d-none");


            var formData = form.serializeArray();
            var jsonData = {
                "url": window.location.href,
                "name": $("#landingName").val(),
                "id": $("#lid").val(),
                "data": objectifyForm(formData)
            };
            $.ajax({
                async: true,
                type: "POST",
                beforeSend: function (request) {
                    request.setRequestHeader("X-LID", $("#lid").val());
                },
                url: formAction,
                dataType: "json",
                contentType: "application/json",
                data: JSON.stringify(jsonData),
                success: function (resp) {
                    //console.log(resp);
                    var obj = JSON.parse(JSON.stringify(resp));
                    if (obj.status === 1) {


                        $("#landing-form").addClass("hidden");
                        $("div.thanks").removeClass("hidden");
                        $(".form-error").addClass("hidden");

                        var loc = location.pathname + "ThankYou";
                        // if (typeof ga !== 'undefined') {
                        //     ga('set', 'page', loc);
                        //     ga('send', 'pageview');
                        // }

                        dataLayer.push({
                            'event': 'VirtualPageview',
                            'virtualPageURL': loc,
                            'virtualPageTitle': 'CNH Clever - Thank You'
                        });

                    } else {

                    }
                },
                error: function (err) {

                    var obj = JSON.parse(err.responseText);
                    //console.log(err);
                    //console.log(obj);

                    var scrollErr = false;
                    if (err.status === 400) {
                        if (obj.status === 3) {
                          //console.log(objResp.validationErrors);
                          $.each(obj.validationErrors, function (k, er) {

                            if (er["fieldName"] == "email") {
                                $("#emailError").removeClass("hidden");
                                $("#emailError1").removeClass("hidden");
                                $("#email").addClass("error");
                               // $("#email").focus();
                                //setTimeout( $("#email").focus(), 10 );
                               if (!scrollErr ) {
                                    $('html, body').animate({
                                        scrollTop: $("#email").offset().top - 100
                                    }, 0);
                                    scrollErr  = true;
                                }
                            }

                            if (er["fieldName"] == "phonenumber") {
                                $("#phoneError").removeClass("hidden");
                                $("#phoneError1").removeClass("hidden");
                                $("#phonenumber").addClass("error");
                                //$("#phonenumber").focus();
                                //setTimeout( $("#phonenumber").focus(), 10 );
                                if (!scrollErr ) {
                                    $('html, body').animate({
                                        scrollTop: $("#phonenumber").offset().top - 100
                                    }, 0);
                                    scrollErr  = true;
                                }
                            }
                            
                           
                           
                          });
                          
                        } else {
                            $("#genericError").removeClass("hidden");
                        }
                      }

                    $(".submit-button").removeAttr("disabled");
                    $("#waiting-form").addClass("d-none");
                }
            });

        }
        return false;
    });

    //create json from form data
    function objectifyForm(formArray) {

        var returnArray = {};
        for (var i = 0; i < formArray.length; i++) {
            returnArray[formArray[i]['name']] = formArray[i]['value'];
        }
        return returnArray;
    }
});




function getUrlParameter(sParam) {

    var sPageURL = decodeURIComponent(window.location.href.substring(window.location.href.indexOf("?") + 1)),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;
    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? true : sParameterName[1];
        }
    }
};

function setPurchaseIntentionText() {
    $("#purchaseintentionText").val($("#purchaseintention option:selected").text());
  }
  
  function contactReasonSelectChange() {
    $("#contactreasonText").val($("#contactreason option:selected").text());
    // if ($("#contactreason option:selected").val() === "4" ) {
    //   $("#contactreasonother").removeClass("d-none");
    // } else {
    //   $("#contactreasonother").addClass("d-none");
    //   $("#contactreasonother").val("");
    // }
  }

  function setProductText() {
    $("#productText").val($("#product option:selected").text());
  }